import { render, staticRenderFns } from "./Curved.vue?vue&type=template&id=550fcff5&lang=true"
import script from "./Curved.vue?vue&type=script&lang=js"
export * from "./Curved.vue?vue&type=script&lang=js"
import style0 from "./Curved.vue?vue&type=style&index=0&id=550fcff5&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports